import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import {
  useColorMode,
  useEditor,
  useSvgExportContext,
  useUniqueSafeId,
  useValue
} from "@tldraw/editor";
import { useGetHashPatternZoomName } from "./defaultStyleDefs.mjs";
function PatternFill({
  d,
  fillColor,
  patternFillFallbackColor,
  scale = 1
}) {
  const editor = useEditor();
  const svgExport = useSvgExportContext();
  const zoomLevel = useValue("zoomLevel", () => editor.getEfficientZoomLevel(), [editor]);
  const colorMode = useColorMode();
  const getHashPatternZoomName = useGetHashPatternZoomName();
  const scaledPatternId = useUniqueSafeId();
  const effectiveZoom = zoomLevel * scale;
  const teenyTiny = effectiveZoom <= 0.18;
  const sharedPatternId = getHashPatternZoomName(effectiveZoom, colorMode);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    !svgExport && !teenyTiny && scale !== 1 && /* @__PURE__ */ jsx(
      "pattern",
      {
        id: scaledPatternId,
        href: `#${sharedPatternId}`,
        patternTransform: `scale(${scale})`
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: fillColor, d }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: svgExport ? `url(#${getHashPatternZoomName(1, colorMode)})` : teenyTiny ? patternFillFallbackColor : scale !== 1 ? `url(#${scaledPatternId})` : `url(#${sharedPatternId})`,
        d
      }
    )
  ] });
}
export {
  PatternFill
};
//# sourceMappingURL=PatternFill.mjs.map
